import { useLocation, useNavigate } from 'react-router-dom';

import { AppURLs } from 'app/utils/appURLs';
import { getFirebaseAccessToken } from 'app/utils/firebase';
import { message } from 'antd';
import { useEffect } from 'react';
import { ROLES } from 'app/configs/roles';

// TODO: Implement redirection after login
const withAuthenticationRequired = <P extends object>(
  Component: React.ComponentType<P>,
  Role: string
): React.FC<P> => {
  return function WithAuthenticationRequired(props: P): JSX.Element {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
      (async (): Promise<void> => {
        const firebaseAccessToken = await getFirebaseAccessToken();
        if (!firebaseAccessToken) {
          if (Role === 'agent') {
            navigate(AppURLs.agentLogin(), {
              state: { from: location.pathname },
            });
            return;
          } else if (Role === 'compliance') {
            navigate(AppURLs.agentLogin(), {
              state: { from: location.pathname },
            });
            return;
          } else if (Role === 'officeAdmin') {
            navigate(AppURLs.agentLogin(), {
              state: { from: location.pathname },
            });
            return;
          } else if (Role === ROLES.ADMIN.toLowerCase()) {
            navigate(AppURLs.agentLogin(), {
              state: { from: location.pathname },
            });
            return;
          } else {
            message.error('Invalid login role. Please contact support.');
            navigate('/');
          }
        }
      })();
    }, [location, navigate]);

    return <Component {...props} />;
  };
};

const RoleProtectedRoute = ({
  Component,
  Role,
}: {
  Component: React.ComponentType;
  Role: string;
}) => {
  const ProtectedComponent = withAuthenticationRequired(Component, Role);

  return <ProtectedComponent />;
};

export default RoleProtectedRoute;
